import React from "react";
import {FourPointStar, CrookedStar} from "../../assets";

const HeroLP = ({ onCTAClick }) => {
  return (
    <section className="st-surface-cream pt-6 sm:pt-8">
      <div className="relative w-full overflow-hidden bg-[--st-color-cream]">
        <div className="relative mx-auto max-w-7xl px-6 pb-16 pt-14 text-center sm:px-10 sm:pb-20 sm:pt-16 md:px-16 lg:pb-24">
          <img
            src={FourPointStar}
            alt=""
            className="pointer-events-none absolute left-[-28px] top-[6%] hidden w-[8rem] md:block lg:left-[-16px] lg:w-[12rem]"
            loading="lazy"
          />
          <img
            src={CrookedStar}
            alt=""
            className="pointer-events-none absolute right-[-34px] top-[34%] hidden w-[10rem] md:block lg:right-[-20px] lg:w-[14rem]"
            loading="lazy"
          />

          <h1 className="st-font-display text-[56px] leading-[0.98] text-[#111111] sm:text-[68px] md:text-[78px] lg:text-[84px]">
            <span className="block text-[0.78em] font-normal italic">Get to Know Your</span>
            <span className="block font-semibold">English Level!</span>
          </h1>

          <p className="st-font-body mx-auto mt-7 max-w-[620px] text-[24px] leading-[1.45] text-[#1F1F1F] sm:text-[26px] md:text-[34px] md:leading-[1.38]">
            Yuk, uji kemampuan Bahasa Inggrismu dengan tes gratis dari Scholarstoday!
          </p>

          <div className="mt-10 flex items-center justify-center gap-2 sm:gap-5">
            <span className="st-placement-pill px-3 py-1.5 text-[13px] sm:px-5 sm:py-2 sm:text-[18px] md:text-[20px]">
              Free &amp; Fun
            </span>
            <button
              type="button"
              onClick={onCTAClick}
              className="st-placement-cta-btn st-placement-cta-btn-navy px-6 py-2.5 text-[19px] hover:-translate-y-[1px] sm:px-10 sm:py-3 sm:text-[28px] md:px-12 md:text-[34px]"
            >
              Start Now!
            </button>
            <span className="st-placement-pill px-3 py-1.5 text-[13px] sm:px-5 sm:py-2 sm:text-[18px] md:text-[20px]">
              Anti Ribet
            </span>
          </div>
        </div>

        <div className="w-full overflow-hidden bg-[#F6CA2D] py-2">
          <div className="st-font-body whitespace-nowrap text-center text-[26px] font-bold uppercase tracking-[0.02em] text-[#BB230B] sm:text-[28px] md:text-[32px]">
            GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO •
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroLP;
